import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@treezor/design-system';

import { useCardUserInfo } from '../hooks/useCardUserInfo';

import { DashboardHelpers } from '@/utils/DashboardHelpers';
import { UserTypes } from '@/features/user/store/user.model';

type TSendToParent = {
  parentUserId: number;
};

export function SendToParent({ parentUserId }: TSendToParent) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { userData: parentUser, isError } = useCardUserInfo({ userId: parentUserId });

  if (!parentUser || isError) return <></>;

  return (
    <div className="flex flex-col">
      <p className="typo-body-regular-paragraph text-tertiary">{t('pages.currentProfiles.cards.card.sendToParent')}</p>
      <div className="flex gap-2 items-center">
        <span className="typo-body-medium-paragraph text-secondary">
          {parentUser.userTypeId == UserTypes.naturalPerson
            ? `${parentUser.firstname} ${parentUser.lastname}`
            : parentUser?.legalName}
        </span>
        <IconButton
          size="s"
          icon="chevron_right"
          variant="secondary"
          type="button"
          onClick={() => navigate(DashboardHelpers.generateProfilePath(parentUser.userId))}
        />
      </div>
    </div>
  );
}
